import { render, staticRenderFns } from "./GroupingFilterV2.vue?vue&type=template&id=470bb49c"
import script from "./GroupingFilterV2.vue?vue&type=script&lang=js"
export * from "./GroupingFilterV2.vue?vue&type=script&lang=js"
import style0 from "./GroupingFilterV2.vue?vue&type=style&index=0&id=470bb49c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports